import { ViewColumn } from "../../../view-column";

export interface ViewColumnState {
  firstColumn: ViewColumn;
  secondColumn: ViewColumn;
  viewCol: ViewColumn[];
  breadCrumbs: ViewColumn[];
  leftDrawer: ViewColumn[];
  rightDrawer: ViewColumn[];
  singleColumn: boolean;
  prevIndex: number;
}

export const initialState: ViewColumnState = {
  firstColumn: null,
  secondColumn: null,
  viewCol: [],
  breadCrumbs: [],
  leftDrawer: [],
  rightDrawer: [],
  singleColumn: true,
  prevIndex: null
};
